module.exports = __webpack_public_path__ + "static/media/brotate.98e08eac.svg";